import {SolutionDrawer} from '@/modules/drug-catalog/solutions/components/solution-drawer/solution-drawer'
import {drawer} from '@cypro/ui/components'
import {SolutionDrugProvider} from '@/shared/contexts/solution-drug'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getSolutionDrawerId(solutionId: string) {
  return `solution-drawer-${solutionId}`
}

export function openSolutionDrawer(solution: DrugCatalogItem) {
  const id = getSolutionDrawerId(solution.id)
  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {solution && (
          <SolutionDrugProvider solutionDrug={solution}>
            <SolutionDrawer />
          </SolutionDrugProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'solution-drawer',
    },
    size: 'lg',
  })
}
